import React, { useState } from "react";
import { motion } from "framer-motion";
import { InputField } from "@cakrawalajakarta/shared-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBoxOpen, faLocationDot } from "@fortawesome/free-solid-svg-icons";

export const Schedule = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const rundown = [
    // Jumat, 14 Agustus 2026
    {
      date: "Jumat, 14 Agustus 2026",
      time: "13.30-20.00",
      activity: "Race Pack Collection (All Categories)",
      location: "Race Venue",
    },
    {
      date: "Jumat, 14 Agustus 2026",
      time: "18.30-19.30",
      activity: "Technical Meeting (All Categories)",
      location: "Race Venue",
    },

    // Sabtu, 15 Agustus 2026
    {
      date: "Sabtu, 15 Agustus 2026",
      time: "03:30",
      activity: "Opening Ceremony",
      location: "Race Venue",
    },
    {
      date: "Sabtu, 15 Agustus 2026",
      time: "04:00",
      activity: "Flag Off 24H",
      location: "Line 2,3",
    },
    {
      date: "Sabtu, 15 Agustus 2026",
      time: "05:00",
      activity: "Flag Off 42K",
      location: "Line 6,7,8",
    },
    {
      date: "Sabtu, 15 Agustus 2026",
      time: "05:00",
      activity: "Flag Off 50K",
      location: "Line 6,7,8",
    },
    {
      date: "Sabtu, 15 Agustus 2026",
      time: "05:00",
      activity: "Flag Off 100K",
      location: "Line 6,7,8",
    },
    {
      date: "Sabtu, 15 Agustus 2026",
      time: "05:00",
      activity: "Flag Off RELAY 50K",
      location: "Line 6,7,8",
    },
    {
      date: "Sabtu, 15 Agustus 2026",
      time: "05:00",
      activity: "Flag Off RELAY 100K",
      location: "Line 6,7,8",
    },
    {
      date: "Sabtu, 15 Agustus 2026",
      time: "10.00-20.00",
      activity: "Race Pack Collection On-Site (Late Pickup)",
      location: "Race Venue",
    },
    {
      date: "Sabtu, 15 Agustus 2026",
      time: "12:00",
      activity: "Cut Off 42K INDIVIDU",
      location: "Line 6,7,8",
    },
    {
      date: "Sabtu, 15 Agustus 2026",
      time: "13:00",
      activity: "Cut Off 50K INDIVIDU",
      location: "Line 6,7,8",
    },
    {
      date: "Sabtu, 15 Agustus 2026",
      time: "13:00",
      activity: "Cut Off 50K RELAY",
      location: "Line 6,7,8",
    },
    {
      date: "Sabtu, 15 Agustus 2026",
      time: "16:00",
      activity: "Flag Off 6H INDIVIDU",
      location: "Line 4,5",
    },
    {
      date: "Sabtu, 15 Agustus 2026",
      time: "16:00",
      activity: "Flag Off 12H INDIVIDU",
      location: "Line 4,5",
    },
    {
      date: "Sabtu, 15 Agustus 2026",
      time: "21:00",
      activity: "Cut Off 100K INDIVIDU",
      location: "Line 6,7,8",
    },
    {
      date: "Sabtu, 15 Agustus 2026",
      time: "21:00",
      activity: "Cut Off 100K RELAY",
      location: "Line 6,7,8",
    },
    {
      date: "Sabtu, 15 Agustus 2026",
      time: "22:00",
      activity: "Cut Off 6H INDIVIDU",
      location: "Line 4,5",
    },

    // Minggu, 16 Agustus 2026
    {
      date: "Minggu, 16 Agustus 2026",
      time: "04:00",
      activity: "Cut Off 12H INDIVIDU",
      location: "Line 4,5",
    },
    {
      date: "Minggu, 16 Agustus 2026",
      time: "04:00",
      activity: "Cut Off 24H INDIVIDU",
      location: "Line 2,3",
    },
    {
      date: "Minggu, 16 Agustus 2026",
      time: "05:00",
      activity: "Opening Ceremony Fun RUN",
      location: "Ring Stadium",
    },
    {
      date: "Minggu, 16 Agustus 2026",
      time: "05:30",
      activity: "Flag Off 10K",
      location: "Race Venue",
    },
    {
      date: "Minggu, 16 Agustus 2026",
      time: "06:00",
      activity: "Flag Off 5K",
      location: "Race Venue",
    },
    {
      date: "Minggu, 16 Agustus 2026",
      time: "07:00",
      activity: "Cut Off 5 KM",
      location: "Race Venue",
    },
    {
      date: "Minggu, 16 Agustus 2026",
      time: "07:30",
      activity: "Cut Off 10 KM",
      location: "Race Venue",
    },
    {
      date: "Minggu, 16 Agustus 2026",
      time: "08.00-10.00",
      activity: "Awarding Ceremony",
      location: "Ring Stadium",
    },
    {
      date: "Minggu, 16 Agustus 2026",
      time: "10:00",
      activity: "Closing",
      location: "Ring Stadium",
    },
  ];

  const filteredRundown = rundown.filter((entry) =>
    Object.values(entry).some((value) =>
      value.toString().toLowerCase().includes(searchQuery.toLowerCase()),
    ),
  );

  const groupedRundown = filteredRundown.reduce((acc, entry) => {
    acc[entry.date] = acc[entry.date] || [];
    acc[entry.date].push(entry);
    return acc;
  }, {});

  return (
    <section
      id="schedule"
      className="w-full min-h-screen py-20 text-center text-slate-900 flex-col justify-center relative bg-white"
    >
      <div className="relative z-0 container mx-auto px-4">
        <div className="max-w-7xl mx-auto">
          <div className="max-w-6xl mx-auto space-y-4">
            {/* Race Pack Collection */}
            <motion.div
              className="grid grid-cols-1 md:grid-cols-2 gap-4"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, ease: "easeInOut" }}
              viewport={{ once: true }}
            >
              <div className="bg-white rounded-2xl px-6 py-8 md:py-12 border border-gray-200 flex flex-col items-center justify-center">
                <FontAwesomeIcon
                  icon={faBoxOpen}
                  className="text-4xl text-slate-500 mb-4"
                />
                <div className="text-lg text-slate-800 font-bold mb-3 flex items-center gap-2">
                  <FontAwesomeIcon
                    icon={faLocationDot}
                    className="text-slate-500"
                  />
                  Race Pack Collection (Pre-Event)
                </div>
                <p className="text-xl text-slate-800">
                  Jumat, 14 Agustus 2026 • 13.30-20.00
                </p>
                <p className="text-sm text-gray-600">
                  All categories • Race Venue
                </p>
              </div>

              <div className="bg-white rounded-2xl px-6 py-8 md:py-12 border border-gray-200 flex flex-col items-center justify-center">
                <FontAwesomeIcon
                  icon={faBoxOpen}
                  className="text-4xl text-slate-500 mb-4"
                />
                <div className="text-lg text-slate-800 font-bold mb-3 flex items-center gap-2">
                  <FontAwesomeIcon
                    icon={faLocationDot}
                    className="text-slate-500"
                  />
                  Race Pack Collection (On-Site)
                </div>
                <p className="text-xl text-slate-800">
                  Sabtu, 15 Agustus 2026 • 19.00-21.00
                </p>
                <p className="text-sm text-gray-600">
                  Late pickup • Race Venue
                </p>
              </div>
            </motion.div>

            {/* Table */}
            <motion.div
              className="bg-white rounded-2xl border border-gray-200 text-left relative overflow-hidden max-w-6xl mx-auto"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, ease: "easeInOut" }}
              viewport={{ once: true }}
            >
              <div className="flex flex-col md:flex-row justify-between items-center mb-4 px-4 pt-4 gap-4">
                <div className="text-left">
                  <h3 className="text-xl font-bold text-slate-900 uppercase tracking-tight">
                    Event Schedule (August 14 – 16, 2026)
                  </h3>
                  <p className="text-sm text-gray-500 italic mt-1">
                    This schedule is current as of August 2026 and is subject to
                    change.
                  </p>
                </div>
                <div className="w-full max-w-xs">
                  <InputField
                    name="search"
                    type="text"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="Cari jadwal..."
                    labelColor="text-slate-800"
                  />
                </div>
              </div>

              <div className="overflow-x-auto">
                <table className="w-full table-auto divide-y divide-gray-200">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
                        Date
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
                        Time
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
                        Activity
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
                        Location
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.keys(groupedRundown).length > 0 ? (
                      Object.entries(groupedRundown).map(([date, entries]) =>
                        entries.map((entry, idx) => {
                          const isCutOff = entry.activity.includes("Cut Off");
                          const isFlagOff = entry.activity.includes("Flag Off");
                          const rowColor = isFlagOff
                            ? "text-brand-red"
                            : isCutOff
                              ? "text-red-700"
                              : "text-gray-600";

                          return (
                            <tr
                              key={`${date}-${idx}`}
                              className="border-b border-gray-200 last:border-b-0 hover:bg-gray-50"
                            >
                              <td className="px-4 py-4 text-sm text-center md:text-left text-gray-600">
                                {idx === 0 ? date : ""}
                              </td>
                              <td className="px-4 py-4 text-sm text-left text-gray-600">
                                {entry.time}
                              </td>
                              <td
                                className={`px-4 py-4 text-sm text-left ${rowColor}`}
                              >
                                {entry.activity}
                              </td>
                              <td className="px-4 py-4 text-sm text-left text-gray-600">
                                {entry.location}
                              </td>
                            </tr>
                          );
                        }),
                      )
                    ) : (
                      <tr>
                        <td
                          colSpan="4"
                          className="px-4 py-4 text-sm text-gray-600 text-center"
                        >
                          No events found matching your search.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};
